// @flow
import api from './';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type {Environment} from "./environment";

type ProjectData = {
  id: ?string,
  name: string,
  key: string
}

export type Project = {
  ...ProjectData,
  id: string,
  environments: Environment[]
}
export type Target = {
  key: string,
  name: string,
  type: string
}

// Define a service using a base URL and expected endpoints
// export const projectApi = createApi({
//   reducerPath: 'projectApi',
//   baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/' }),
//   endpoints: (builder) => ({
//     getProjectByKey: builder.query<Project, string>({
//       query: (key) => `projects/${key}`,
//     }),
//   }),
// })



// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
// export const { useGetProjectByKeyQuery } = projectApi


// export default projectApi;

export function list(){
    return api('get', `/api/v1/projects`)
}

export function get(projectKey: string){
  return api('get', `/api/v1/projects/${projectKey}`)
}
export function find(query: string){
  if(query !== null && query.length > 0){
    return api('get', `/api/v1/projects?query=${query}`)
  }else{
    return api('get', `/api/v1/projects`)
  }

}

export function update(data: ProjectData){
  return api(data.id ? 'put' : 'post', `/api/v1/projects`, {
    data
  })
}

export function remove(projectKey: string){
  return api('delete', `/api/v1/projects/${projectKey}`)
}

export function getTargetValues(projectKey: string, target: string, query: string = ''){
  return api('get', `/api/v1/projects/${projectKey}/targets/${target}/values?query=${query}`)
}

export function getGoals(projectKey: string, query: string = ''){
  return api('get', `/api/v1/goals?projectKey=${projectKey}&query=${query}`)
}


export function getTags(projectKey: string, query: string = ''){
  return api('get', `/api/v1/projects/${projectKey}/tags?query=${query}`)
}

export function getTargets(projectKey: string, query: string = ''){
    return api('get', `/api/v1/projects/${projectKey}/targets?query=${query}`)
}

export function createTarget(projectKey: string, key: string, name: string, type: string){
  return api('post', `/api/v1/projects/${projectKey}/targets`, {
    data: {
      key,
      type,
      name
    }
  })
}